import { type ParseKeys } from 'i18next';
import { type BigDecimalRangeDto, isRangeDto, type SearchListing } from '@pkgs/api';

import { type TRANSLATION_NAMESPACE } from '@/i18n/config';

export const getSpecificLivingAreaLabel = (property: SearchListing): ParseKeys<typeof TRANSLATION_NAMESPACE.property_expose> => {
  if (property.isDevelopmentProject) {
    return 'search.expose.propertyDetails.development.label.livingArea';
  }

  return 'search.expose.propertyDetails.label.livingArea';
};

export const getCountFromValue = (value: number | string | BigDecimalRangeDto): number => {
  if (isRangeDto(value) && value.min) return value.min;
  if (isRangeDto(value) && value.max) return value.max;
  return Number(value);
};
